import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "topbar-item"
  }, [_c('div', {
    staticClass: "btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto",
    attrs: {
      "id": "kt_quick_user_toggle"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          path: '/perfil'
        });
      }
    }
  }, [_c('span', {
    staticClass: "symbol symbol-35"
  }, [_vm._v(_vm._s(_vm.currentUser.nome))])]), _c('div', {
    ref: "kt_quick_user",
    staticClass: "offcanvas offcanvas-right p-10",
    attrs: {
      "id": "kt_quick_user"
    }
  }, [_vm._m(0), _c('perfect-scrollbar', {
    staticClass: "offcanvas-content pr-5 mr-n5 scroll",
    staticStyle: {
      "max-height": "90vh",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mt-5"
  }, [_c('div', {
    staticClass: "symbol symbol-100 mr-5"
  }), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('a', {
    staticClass: "font-weight-bold font-size-h5 text-dark-75",
    attrs: {
      "href": "#/usuarios"
    }
  }, [_vm._v(" " + _vm._s(_vm.currentUser.nome) + " ")]), _c('a', {
    staticClass: "font-weight-bold font-size-h5 text-dark-75 text-hover-primary",
    attrs: {
      "href": "#/usuarios"
    }
  }), _c('div', {
    staticClass: "navi mb-2"
  }, [_c('a', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: 'Clique aqui para editar',
      expression: "'Clique aqui para editar'"
    }],
    staticClass: "navi-item",
    attrs: {
      "href": "#/perfil"
    }
  }, [_c('span', {
    staticClass: "navi-link p-0 pb-2"
  }, [_c('span', {
    staticClass: "navi-text text-muted text-hover-primary",
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(" Ver perfil ")])])])]), _c('button', {
    staticClass: "btn btn-light-primary btn-bold",
    on: {
      "click": _vm.onLogout
    }
  }, [_vm._v(" Sair ")])])])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "offcanvas-header d-flex align-items-center justify-content-between pb-5"
  }, [_c('h3', {
    staticClass: "font-weight-bold m-0"
  }, [_vm._v("Perfil do usuário")]), _c('a', {
    staticClass: "btn btn-xs btn-icon btn-light btn-hover-primary",
    attrs: {
      "href": "#",
      "id": "kt_quick_user_close"
    }
  }, [_c('i', {
    staticClass: "ki ki-close icon-xs text-muted"
  })])]);
}];
export { render, staticRenderFns };